/* eslint-disable @typescript-eslint/no-explicit-any */
import { Breadcrumb, Col, Form, Input, Row, Select, Space, Table } from 'antd';
import Button from 'components/Button';
import MainLayout from 'components/Modules/Layout/MainLayout';
import useQueryParam from 'hooks/useQueryPrams';
import { IGetUserQuery } from 'interface/user.interface';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { Link, useHistory } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { HocChangePagination } from 'utils/HocChangePagination';
import updateQueryStringParameter from 'utils/updateQueryStringParameter';
import {
  AddIcon,
  EditIcon,
  EyeIcon,
  FilterGoldIcon,
  FilterIcon,
} from 'assets/svg';
import { Content } from 'antd/es/layout/layout';

import { IBrand, IGetBrandQuery } from 'interface/brand.interface';
import BrandApi from 'apis/BrandApi';
import handleError401 from 'utils/handleError401';
import { translateAction } from 'utils/translateStatus';
import { activeStatus } from 'mock/status-mockup';
import pageTitleStore from 'store/pageTitleStore';
import { ColumnsType } from 'antd/es/table';

type FixedType = 'left' | 'right' | boolean;

export default function BrandPage(): JSX.Element {
  const history = useHistory();

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

  const queryParam = useQueryParam();

  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const grp_name = queryParam.get('grp_name') || undefined;
  const email = queryParam.get('email') || undefined;
  const active = queryParam.get('active') || undefined;
  const grp_code = queryParam.get('grp_code') || undefined;

  const pofTypeParams: IGetBrandQuery = {
    page,
    page_size,
    // id: id,
    grp_code: undefined,
    grp_name,
    active,
    grp_level: 3,
    email,
  };

  const params = JSON.parse(JSON.stringify(pofTypeParams));

  const [brandDataDrops, setBrandDataProps] = useState<IBrand>();
  const [disabledField, setDisableField] = useState<boolean>(false);

  const pathSnippets = location.pathname.split('/').filter((i) => i);
  const [brandData, setBrandData] = useState<any>();
  const handleShowBrandDetailModal = (record: any) => {
    // setIsRatingDetail(true);
    setBrandDataProps(record);
    setDisableField(true);
    history.push(`/brand/details`, record);
  };

  const handleEditDetailModal = (record: any) => {
    // setIsRatingDetail(true);
    setBrandDataProps(record);
    setDisableField(true);
    history.push(`/brand/edit`, record);
  };

  const columns: ColumnsType<any> = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Bộ phận phát triển',
      dataIndex: 'grp_name',
      width: 177,
    },
    {
      title: 'Người quản lý',
      dataIndex: 'list_user',
    },
    {
      title: 'Trạng thái',
      dataIndex: 'active',
      width: 155,
      render: (_: any, record: any) => (
        <span>{translateAction(record.active)}</span>
      ),
    },
    {
      title: 'Thao tác',
      fixed: 'right' as FixedType,
      width: 100,
      render: (record: any) => (
        <div className="flex justify-around">
          <button onClick={() => handleShowBrandDetailModal(record)}>
            <EyeIcon />
          </button>
          <button onClick={() => handleEditDetailModal(record)}>
            <EditIcon />
          </button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    setTitle('Bộ phận phát triển');
    setBreadcrumb([{ title: <a href="/brand">Bộ phận phát triển</a> }]);
  }, []);

  const onFinish = (values: any) => {
    const search: Partial<IGetUserQuery> = JSON.parse(
      JSON.stringify({
        ...values,
        page: 1,
        page_size: page_size,
      })
    );

    history.push({
      pathname: location.pathname,
      search: updateQueryStringParameter(location.search, search),
    });
  };

  const onGoToAddCategory = () => {
    history.push('/brand/add-brand');
  };

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };

  const { data: data } = useQuery(
    ['getBrandTitle', pofTypeParams],
    () => BrandApi.getBrand(params),
    {
      onSuccess: (data) => {
        const listProduct = [];
        for (let i = 0; i < data.data.length; i++) {
          let listEmail = '';
          if (data.data[i].list_user.length > 0) {
            for (let j = 0; j < data.data[i].list_user.length; j++) {
              if (data.data[i].list_user[j] != null) {
                if (listEmail != '') {
                  listEmail = listEmail + '; ';
                }
                listEmail =
                  listEmail +
                  data.data[i].list_user[j].fullName +
                  ' - ' +
                  data.data[i].list_user[j].departmentName;
              }
            }
          }
          listProduct.push({
            id: data.data[i].id,
            grp_code: data.data[i].grp_code,
            grp_name: data.data[i].grp_name,
            grp_description: data.data[i].grp_description,
            active: data.data[i].active,
            list_user: listEmail,
            list_user_drop: data.data[i].list_user,
            grp_level: data.data[i].grp_level,
            parent_id: data.data[i].parent_id,
          });
        }
        setBrandData(listProduct);
      },
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  return (
    <MainLayout isLoading={false}>
      {/* <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1"
      >
      <div>
        <Breadcrumb items={breadcrumbItems} />
        <p className="text-[#00538F] font-bold text-2xl">Nhãn hàng</p>
      </div>
      </Row> */}

      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
        <Col span={12} className="flex justify-end">
          <Space>
            <Button onClick={onGoToAddCategory}>
              <AddIcon />
              Tạo mới
            </Button>
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>

      <Form
        layout="vertical"
        className={`items-center ${isOpenFilter ? '' : 'hidden'} mt-4`}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Content>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={8}>
              <Form.Item name="grp_name" label="Bộ phận phát triển">
                <Input placeholder="Nhập bộ phận phát triển" />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item name="active" label="Trạng thái">
                <Select
                  defaultValue={'active'}
                  options={activeStatus}
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item name="email" label="Email người tạo">
                <Input placeholder="Nhập email người tạo" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={toggleFilter}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="main-content mt-4">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          className="customTable"
          dataSource={brandData}
          scroll={{ x: 958 }}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: data?.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
    </MainLayout>
  );
}
